import React from 'react';
import { useIntl } from 'react-intl';
import { staticConfig } from '../../../config/static';

import styles from './headermenu.module.scss';
import { closePopupOFocusOut } from '../../../helpers/general';

const { listHeader, subMenu } = styles;

export const PrivateMenu = (props: any): JSX.Element => {
    const { formatMessage } = useIntl();
    const classicLogonPlace = localStorage.getItem('classicLogonPlace');
    const classicMailboxLink = staticConfig?.classicMailboxLink?.replace('{domainType}', classicLogonPlace);
    const classicLink = classicMailboxLink?.replace('/mailbox', '');

    return (
        <nav className={subMenu}>
            <ul>
                <li className={listHeader}>
                    <a href={`${classicLink}/registrations`}>{formatMessage({ id: 'REGISTRATIONS' })}</a>
                </li>

                <li>
                    <a href={`${classicLink}/registrations/myregistrations`}>{formatMessage({ id: 'MY_SENDERS' })}</a>
                </li>
                <li>
                    <a href={`${classicLink}/registrations`}>{formatMessage({ id: 'ALL_SENDERS_TEXT' })}</a>
                </li>
                <li>
                    <a href={`${classicLink}/receipts`}>{formatMessage({ id: 'RECEIPTS' })}</a>
                </li>
                <li>
                    <a href={`${classicLink}/publicmailsubscription`}>
                        {formatMessage({ id: 'MENU_MAIL_REGISTER_PUBLIC' })}
                    </a>
                </li>
            </ul>

            <ul>
                <li className={listHeader}>
                    <a href={`${classicLink}/settings/profile`}>{formatMessage({ id: 'SETTINGS' })}</a>
                </li>
                <li>
                    <a href={`${classicLink}/settings/profile`}>
                        {formatMessage({ id: 'TEXT_SETTINGS_PROFILE_CLASSIC' })}
                    </a>
                </li>
                <li>
                    <a href="/settings/profile">{formatMessage({ id: 'TEXT_SETTINGS_PROFILE_NGDP' })}</a>
                </li>
                <li>
                    <a href={`${classicLink}/settings/rules`}>{formatMessage({ id: 'ARCHIVING_RULES' })}</a>
                </li>
                <li>
                    <a href={`${classicLink}/settings/notifications/exceptionlist`}>
                        {formatMessage({ id: 'NEW_MAIL_NOTIFICATION' })}
                    </a>
                </li>
                <li>
                    <a href={`${classicLink}/settings/receiptrules`}>{formatMessage({ id: 'OPENING_RECEIPTS' })}</a>
                </li>
                <li>
                    <a href={`${classicLink}/settings/mobileaccess`}>{formatMessage({ id: 'MOBILE_ACCESS' })}</a>
                </li>
                <li>
                    <a href={`${classicLink}/settings/sharedfolders`}>{formatMessage({ id: 'MENU_SHARED_FOLDERS' })}</a>
                </li>
                <li>
                    <a href={`${classicLink}/settings/cancel`}>{formatMessage({ id: 'CANCEL_EBOKS' })}</a>
                </li>
                <li
                    onBlur={(e) => {
                        closePopupOFocusOut(e, true) && props.toggleDropdown();
                    }}
                >
                    <a href={`${classicLink}/settings/publicmailsdeleteduplicates`}>
                        {formatMessage({ id: 'MANAGE_PUBLIC_MAIL' })}
                    </a>
                </li>
            </ul>
        </nav>
    );
};
